/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntityTypeEnum } from './entityTypeEnum';


export interface ValidateUpgradeSpec { 
    /**
     * Id of entity passed in request body to check for validations.
     */
    id: string;
    entity_type: EntityTypeEnum;
}
export namespace ValidateUpgradeSpec {
}


